// =========================================================
// * Vuetify Material Dashboard PRO - v1.0.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueTheMask from 'vue-the-mask'
import VueGeolocation from 'vue-browser-geolocation'
import ClientForm from './views/admin/components/Client-form.vue'
import PlaceForm from './views/admin/components/Place-form.vue'
import DeviceForm from './views/admin/components/Device-form.vue'
import EquipmentForm from './views/admin/components/Equipment-form.vue'
import PointForm from './views/admin/components/Point-form.vue'
import OperatorForm from './views/admin/components/Operator-form.vue'
import RecipientForm from './views/admin/components/Recipient-form.vue'
import ItemForm from './views/admin/components/Item-form.vue'
import OrderForm from './views/admin/components/Order-form.vue'
import FiscalForm from './views/admin/components/Fiscal-form.vue'
import PaymentForm from './views/admin/components/Payment-form.vue'
import SummaryForm from './views/admin/components/Summary-form.vue'
import UserForm from './views/admin/components/User-form.vue'
import RoleForm from './views/admin/components/Role-form.vue'
import KktForm from './views/admin/components/Kkt-form.vue'
import UniversalForm from './views/admin/components/Universal-form.vue'
import UniversalTable from './views/admin/components/Universal-table.vue'
import UploadFiles from './views/admin/components/UploadFiles.vue'
import ConfigurationForm from './views/admin/components/Configuration-form.vue'
import PasswordChangeForm from './views/admin/components/Password-change-form.vue'
import row from './views/admin/components/row'
import condition from './views/admin/components/condition'
import './sass/materialdesignicons.min.css'

Number.prototype.money = function () {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).format(this)
}
if (process.env.VUE_APP_MODE === 'production') {
  Vue.config.productionTip = false // Отключает сообщение "You are running Vue in development mode"
  Vue.config.silent = true // Отключает все предупреждения и логи Vue
  console.log = function () {}
}
Vue.component('ClientForm', ClientForm)
Vue.component('PlaceForm', PlaceForm)
Vue.component('DeviceForm', DeviceForm)
Vue.component('EquipmentForm', EquipmentForm)
Vue.component('PointForm', PointForm)
Vue.component('OperatorForm', OperatorForm)
Vue.component('RecipientForm', RecipientForm)
Vue.component('ItemForm', ItemForm)
Vue.component('OrderForm', OrderForm)
Vue.component('FiscalForm', FiscalForm)
Vue.component('PaymentForm', PaymentForm)
Vue.component('SummaryForm', SummaryForm)
Vue.component('UserForm', UserForm)
Vue.component('RoleForm', RoleForm)
Vue.component('KktForm', KktForm)
Vue.component('UniversalForm', UniversalForm)
Vue.component('UniversalTable', UniversalTable)
Vue.component('UploadFiles', UploadFiles)
Vue.component('ConfigurationForm', ConfigurationForm)
Vue.component('PasswordChangeForm', PasswordChangeForm)
Vue.component('row', row)
Vue.component('condition', condition)
Number.prototype.money = function () {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).format(this)
}
Vue.use(VueGeolocation)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next('/admin/')
  }
  if (to.path === '/logout') {
    window.localStorage.removeItem('token')
    next('/pages/login')
  } else
  if (to.path === '/pages/login' || to.path === '/pages/recover' || to.path == '/pages/confirmation' || to.path == '/cheque' || to.path == '/loyalty/login' || to.path == '/loyalty/recover' || to.path.includes('/crowd') ||
      to.path.startsWith('/qrpayment') || to.path.startsWith('/ps') || to.path.startsWith('/qr') || to.path.startsWith('/pm') || to.path.startsWith('/ppr') || to.path.startsWith('/carwash')) {
    // store.state.toolbar.show = false
    next()
  } else {
    window.axios.post('/api/auth/check/', {
      client: localStorage.getItem('client'),
      path: to.path,
    })
        .then(response => {
          if (!response.data.error) {
            store.commit('user', response.data.user)
            store.commit('client', response.data.client)
            if (response.data.token) localStorage.setItem('token', response.data.token)
            const obj = {}
            for (const x in response.data.dictionaries) {
              const dict = response.data.dictionaries[x]
              const data = {}
              for (const y in dict.data) {
                if (dict.data[y].enabled) {
                  data[dict.data[y].value] = dict.data[y].data
                }
              }
              obj[dict.name] = data
            }
            // Стандартные справочники
            obj.log = {
              1: 'Создание клиента',
              2: 'Изменение клиента',
              3: 'Создание события',
              4: 'Изменение события',
              5: 'Создание договора',
              6: 'Изменение договора',
              7: 'Создание пользователя',
              8: 'Изменение пользователя',
              9: 'Регистрация пользователя',
              10: 'Создание словаря',
              11: 'Изменение словаря',
              12: 'Авторизация пользователя',
              13: 'Создание настроек',
              14: 'Изменение настроек',
              15: 'Создание таблицы',
              16: 'Изменение таблицы',
              17: 'Создание сущности',
              18: 'Изменение сущности',
              19: 'Ошибка',
              20: 'Создание документа',
              21: 'Изменение документа',
              22: 'Создание папки',
              23: 'Изменение папки',
              24: 'Отправка СМС',
              25: 'Отправка E-mail',
              26: 'Создание места обслуживания',
              27: 'Изменение места обслуживания',
              28: 'Создание устройства',
              29: 'Изменение устройства',
              30: 'Создание точки',
              31: 'Изменение точки',
              32: 'Создание оператор',
              33: 'Изменение оператор',
              34: 'Создание получателя',
              35: 'Изменение получателя',
              36: 'Создание товара',
              37: 'Изменение товара',
              38: 'Создание заказа',
              39: 'Изменение заказа',
              40: 'Создание фискальной операции',
              41: 'Изменение фискальной операции',
              42: 'Создание платежа',
              43: 'Изменение платежа',
              44: 'Создание плательщика',
              45: 'Изменение плательщика',
              46: 'Создание роли',
              47: 'Изменение роли',
              48: 'Создание платежа СБП',
              49: 'Изменение платежа СБП',
              54: 'Создание номенклатуры',
              55: 'Изменение номенклатуры'
            },
            store.commit('dictionary', obj)
            const access = {}
            for (const x in response.data.accesses) {
              const item = response.data.accesses[x]
              access[item.entity] = access[item.entity] || {}
              access[item.entity][item.type] = access[item.entity][item.type] || false
              for (const x in response.data.user.organizations.filter(a => !localStorage.getItem('client') || localStorage.getItem('client') == a.client)) {
                if (response.data.user.organizations[x].role == 1 && !to.path.startsWith('/admin')) continue
                if (response.data.user.organizations[x].role == 2 && !to.path.startsWith('/client')) continue
                if (response.data.user.organizations[x].role == 3 && !to.path.startsWith('/common')) continue
                if (item.roles.indexOf(response.data.user.organizations[x].role) > -1) {
                  if (response.data.user.organizations[x].custom_role_item) {
                    if (response.data.user.organizations[x].custom_role_item.accesses[item.entity] && response.data.user.organizations[x].custom_role_item.accesses[item.entity].indexOf(item.type) > -1) { access[item.entity][item.type] = true }
                  } else {
                    access[item.entity][item.type] = true
                  }
                }
              }
            }
            store.commit('access', access)
            store.commit('clients', response.data.clients)
            const roles = {}
            for (const x in response.data.user.organizations) {
              const item = response.data.user.organizations[x]
              roles[Number(item.role)] = item
            }
            console.log(roles)
            store.commit('roles', roles)
            if (to.path.startsWith('/admin') && (!roles[1])) {
              next('/client/')
            } else if (to.path.startsWith('/client') && (!roles[2])) {
              next('/common/services')
            } else {
              next()
            }
          } else {
            next('/pages/login')
        }
      })
      .catch(e => {
        console.log(e)
        next('/pages/login')
      })
  }
})
Vue.directive('phone', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }

      const x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      el.dispatchEvent(new Event('input'))
    }
  },
})

Vue.use(VueTheMask)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
